import './PetModal.css';
import { ModalContainer } from '../modalContainer/ModalContainer';
import {
  imageURLForAsset,
  petTypeNameForId,
  iconURLForSpecialty,
  nameForSpecialty,
  iconURLForBonusType,
  nameForBonusTypeAndValue,
  iconURLForRarityId,
  rarityNameFor
} from '../../assetHelpers';

export const PetModal = (props) => {

  const { pet } = props;

  if (!pet) { return null; }

  return (
    <ModalContainer
      title={pet.name}
      smallPromptFormat={false}
      hideHeaderDismissButton={false}
      onDismiss={props.onDismiss}
    >
      <div className="petModalContentWrapper">
        <div className="petDetailsSectionLeft">
          <div className="flip-container">
            <div className="flipper">
              <div className="front">
                <img src={imageURLForAsset(pet.hasOwnProperty("visualId") ? pet.visualId.toLowerCase() : "placeholder")}/>
              </div>
              <div className="back">
                <img src={imageURLForAsset("placeholder")}/>
              </div>
            </div>
          </div>
        </div>
        <div className="petDetailsSectionRight">
          <div className="petDetailsSummary">

            <h1>{pet.name}</h1>
            <h2>{petTypeNameForId(pet.visualId)}</h2>

            {pet && pet.specialty ?
              <div className="specialties">
                Specialty:
                  <img src={iconURLForSpecialty(pet.specialty)} /> <strong>{nameForSpecialty(pet.specialty)}</strong>
              </div>
            :
              null
            }
            {pet && pet.bonus ?
              <div className="bonusType">
              Bonus:
                <img src={iconURLForBonusType(pet.bonus.type)} /> <strong>{nameForBonusTypeAndValue(pet.bonus.type, pet.bonus.value)}</strong>
              </div>
            :
            null
            }
            {pet.hasOwnProperty("rarity") ?
              <div className="availability">
                Rarity: <img src={iconURLForRarityId(pet.rarity)} className="rarityStars" /> <strong>{rarityNameFor(pet.rarity)}</strong>
              </div>
            :
              <div className="availability">
                Rarity: ?
              </div>
            }
            {pet.hasOwnProperty("level") ?
              <div className="description">
                Level: {pet.level}
              </div>
            :
              null
            }
            {props.parentComponentExtendedContent}
          </div>
        </div>
      </div>
    </ModalContainer>
  );
}

export default PetModal;